import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.558 8.442 12.596 10H9.622l-1.856 2H15v-2l-1.778-2.667A1.32 1.32 0 0 1 13 6.6v-.238L11.368 8.12c.057.11.12.218.19.322Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.033 2.044 13.002 1h2.495L2.5 15H0l2.786-3H1v-2l1.778-2.667A1.32 1.32 0 0 0 3 6.6V5a5 5 0 0 1 9.033-2.956Zm-1.403 1.51A3 3 0 0 0 5 5v1.6a3.32 3.32 0 0 1-.558 1.842L3.404 10h1.24l5.986-6.445Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8 16a2.998 2.998 0 0 1-2.523-1.377L6.993 13H7a1 1 0 1 0 2 0h2a3 3 0 0 1-3 3Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconActionUnsubscribe16 = createIcon(IconComponent);